import React, {useEffect, useRef, useState} from "react";
import html2canvas from "html2canvas";
import {jsPDF} from "jspdf";
import BaseScreen from "../base/BaseScreen";
import styled from "styled-components";
import backLogo from "../../resources/images/back.svg";
import '../datepicker.scss';
import {device} from "../../constants/breakpoints";
import Api from "../../util/Api";
import {useHistory} from "react-router-dom";
import {PlanOfActionTabs} from "../../constants/enums";
import QuestionsListCard from "./QuestionsListCard";
import AppStorage, {StorageKey} from "../../util/AppStorage";
import {
    BackgroundedScreen,
    HeaderLogo,
    HeaderTitle,
    inter,
    lemonMilk,
    primaryPink,
    primaryPurple,
    secondaryGreenLight,
    secondaryRed,
    white
} from "../../Theme";
import {Loader} from "../../components/Loader";
import {showNativeNavigation} from "../../AppInterface";
import {ExecutiveFunctionsCard} from './ExecutiveFunctionsCard';
import {PlanOfActionTabletFooter} from './PlanOfActionFooter';
import showBasicPopup from "../../popups/showBasicPopup";
import {Spinner} from "../../components/Spinner";
import {useQuery} from "../../App";
import {ReactComponent as DownloadIcon} from "../../resources/icons/download.svg";
import { PlanOfActionScreenExport } from "./PlanOfActionScreenExport";
import {useMenuDataContext} from "../../contexts/MenuDataContext";
import { usePageDataContext } from "../../contexts/PageDataContext";
import { PupilSchoolYearSelector } from "../../components/PupilSchoolYearSelector/PupilSchoolYearSelector";
import {getContextParams, getFilterParams} from "../../util/ParamsHelpers";
import { PageHeader } from "../../components/PageHeader/PageHeader";

function PlanOfActionScreen(props) {
    const history = useHistory();
    const {gradeOptions, pupilOptions} = useMenuDataContext();
    const [period, setPeriod] = useState(history.location.state ? history.location.state.period : null)
    const [answers, setAnswers] = useState(null);
    const [checkItems, setCheckItems] = useState(null);
    const [activeTab, setActiveTab] = useState(PlanOfActionTabs.EF)
    const [isLoading, setIsLoading] = useState(false)
    const [isExportingPdf, setIsExportingPdf] = useState(false)
    const captureRef = useRef(null)
    const query = useQuery();
    const {schoolYearsData, selectedSchoolYear, isSchoolYearContextReady} = usePageDataContext();

    const getExportSubtitle = () => {
        const pupilId = AppStorage.get(StorageKey.PUPIL_ID);
        const gradeId = AppStorage.get(StorageKey.GRADE_ID);
        const pupilLabel = pupilOptions?.find((item) => item.value === pupilId)?.label;
        const gradeLabel = gradeOptions?.find((item) => item.value === gradeId)?.label;

        let subtitle = `Naam: ${pupilLabel ?? "—"} Klas: ${gradeLabel ?? "—"}`;

        // Check if a different year is selected
        if (schoolYearsData?.[0]?.id !== selectedSchoolYear?.value) {
            subtitle += ` Schooljaar: ${selectedSchoolYear.label}`;
        }

        return subtitle;
    };

    useEffect(() => {
        if (!isSchoolYearContextReady) return;

        if (query.get("activeTab") !== null) setActiveTab(query.get("activeTab"))
        showNativeNavigation();
        getPeriod()
        getAnswers()
        getCheckItems()
        // eslint-disable-next-line
    }, [selectedSchoolYear?.value, isSchoolYearContextReady]);

    const content = (
        <BackgroundedScreen>
            {((!period && !answers) || !isSchoolYearContextReady) &&
                <Loader />
            }

            {period && answers &&
                <>
                    <PlanOfActionScreenExport
                        ref={captureRef}
                        period={period}
                        subtitle={getExportSubtitle()}
                        {...props}
                    />
                    <HeaderContentFooterWrapper>

                        <ScreenContent>

                            <SelectorContainer>
                                <SelectorWrapper>
                                    <PupilSchoolYearSelector />
                                </SelectorWrapper>
                            </SelectorContainer>

                            <StyledPageHeader>
                                <PageHeader.Start>
                                    <HeaderLogo src={backLogo} onClick={() => {
                                        history.push("/ef-voortgang");
                                    }}/>
                                </PageHeader.Start>
                                <StyledPageHeaderCenter>
                                    <HeaderTitle>{period && period.title}</HeaderTitle>
                                    {activeTab === PlanOfActionTabs.EF && (
                                        <DownloadButtonMobile
                                            type="button"
                                            disabled={isExportingPdf}
                                            onClick={handleDownloadPdf}
                                        >
                                            <StyledDownloadIcon />
                                        </DownloadButtonMobile>
                                    )}
                                </StyledPageHeaderCenter>
                            </StyledPageHeader>

                            <TabWrapper>
                                <TabBar $hasDownloadButton={activeTab === PlanOfActionTabs.EF}>
                                    <Tab isActive={activeTab === PlanOfActionTabs.EF}
                                        onClick={() => setActiveTab(PlanOfActionTabs.EF)}>
                                        {PlanOfActionTabs.EF}
                                    </Tab>
                                    <Tab isActive={activeTab === PlanOfActionTabs.PLANOFACTION}
                                        onClick={() => setActiveTab(PlanOfActionTabs.PLANOFACTION)}>
                                        {PlanOfActionTabs.PLANOFACTION}
                                    </Tab>
                                    <Tab isActive={activeTab === PlanOfActionTabs.EVALUATION}
                                        onClick={() => setActiveTab(PlanOfActionTabs.EVALUATION)}>
                                        {PlanOfActionTabs.EVALUATION}
                                    </Tab>
                                </TabBar>

                                {activeTab === PlanOfActionTabs.EF && (
                                    <DownloadButtonDesktop
                                        type="button"
                                        disabled={isExportingPdf}
                                        onClick={handleDownloadPdf}
                                    >
                                        <StyledDownloadIcon />
                                    </DownloadButtonDesktop>
                                )}
                            </TabWrapper>

                            <ExecutiveFunctionsCard
                                period={period}
                                activeTab={activeTab}
                                type={PlanOfActionTabs.EF}
                                {...props}
                            />
                            <QuestionsListCard
                                period={period}
                                answers={answers}
                                activeTab={activeTab}
                                type={PlanOfActionTabs.PLANOFACTION}
                                onSave={(answerData) => {
                                    saveAnswer(answerData)
                                }}
                                isLoading={isLoading}
                                checkItems={checkItems}
                                {...props}
                            />
                            <QuestionsListCard
                                period={period}
                                answers={answers}
                                activeTab={activeTab}
                                type={PlanOfActionTabs.EVALUATION}
                                onSave={(answerData) => {
                                    saveAnswer(answerData)
                                }}
                                isLoading={isLoading}
                                {...props}
                            />

                        </ScreenContent>
                        <PlanOfActionTabletFooter {...props} />
                    </HeaderContentFooterWrapper>
                </>
            }
        </BackgroundedScreen>
    );

    return (
        <BaseScreen
            activeMenuItem={"EF in beeld"}
            content={content}
        />
    )

    function getPeriod() {
        const params = getContextParams();
        if (!params) return;

        const config = {
            params: {
                ...params,
            }
        }

        Api.get('periods/' + props.match.params.id, onSuccess, null, null, null, config);

        function onSuccess(response) {
            if (response?.data?.scoresPerExecutiveFunction?.filter(ef => ef.totalScore == null)?.length > 0) {
                history.replace("/ef-voortgang");
                return;
            }
            setPeriod(response.data)
        }
    }

    function getAnswers() {
        const config = {
            params: getFilterParams({
                'filter[periodId]': props.match.params.id,
            }),
        };

        Api.get("/pupils/" + AppStorage.get(StorageKey.PUPIL_ID) + "/answers", (response) => {
            setAnswers(response.data);
        }, null, null, null, config);
    }

    function saveAnswer(answerData) {
        const config = {
            params: getFilterParams({
                'filter[periodId]': props.match.params.id,
            }),
        };

        setIsLoading(true)
        Api.put(
            "/pupils/" + AppStorage.get(StorageKey.PUPIL_ID) + "/answers",
            answerData,
            () => {
                showBasicPopup(
                    "Antwoorden opgeslagen!",
                    "Je antwoorden zijn succesvol opgeslagen. Je kan deze pagina verlaten.",
                    "OK"
                )
            },
            null,
            null,
            null,
            config,
            () => setIsLoading(false)
        );
    }

    function getCheckItems() {
        const config = {
            params: getFilterParams({
                'filter[periodId]': props.match.params.id,
                'filter[focusChecklist]': true,
            }),
        };

        Api.get("/pupils/" + AppStorage.get(StorageKey.PUPIL_ID) + "/checkItems", (response) => {
            setCheckItems(response.data);
        }, null, null, null, config);
    }

    async function handleDownloadPdf() {
        if (!captureRef.current || isExportingPdf) return;

        setIsExportingPdf(true);

        try {
            const canvas = await html2canvas(captureRef.current, {
                scale: Math.min(2, window.devicePixelRatio || 1.5),
                logging: false,
                backgroundColor: null, // transparent
            })

            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF();

            // All sizes are in millimeters
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const margin = 10;
            const maxWidth = pageWidth - 2 * margin;
            const maxHeight = pageHeight - 2 * margin;
            
            // Fit the image with aspect ratio (as wide as possible, if too tall, make it as tall as possible)
            let drawWidth = maxWidth;
            let drawHeight = (canvas.height * drawWidth) / canvas.width;
            if (drawHeight > maxHeight) {
                drawHeight = maxHeight;
                drawWidth = (canvas.width * drawHeight) / canvas.height;
            }

            const x = margin + (maxWidth - drawWidth) / 2;
            const y = margin + (maxHeight - drawHeight) / 2;

            // Fill PDF gradient background
            const exportHeight = Math.max(captureRef.current.offsetHeight, 1);
            const backgroundGradientPosition = y + (250 / exportHeight) * drawHeight; // The gradient switches at 250px from the top
            const maxBackgroundGradientPosition = Math.max(0, Math.min(backgroundGradientPosition, pageHeight));

            pdf.setFillColor(200, 225, 192); // primaryGreen
            pdf.rect(0, 0, pageWidth, maxBackgroundGradientPosition, "F");
            pdf.setFillColor(237, 245, 232); // secondaryGreenLight
            pdf.rect(0, maxBackgroundGradientPosition, pageWidth, pageHeight - maxBackgroundGradientPosition, "F");

            pdf.addImage(imgData, "PNG", x, y, drawWidth, drawHeight);

            pdf.save(`${period.title ?? "EF in beeld"}.pdf`)
        } catch (e) {
            console.error(e)
            showBasicPopup(
                "Download mislukt",
                "Het is niet gelukt om de PDF te downloaden. Probeer het opnieuw.",
                "OK"
            )
        } finally {
            setIsExportingPdf(false)
        }
    }
}

export function SaveButton({onClick, isLoading = false}) {
    return (
        <SaveButtonRoot onClick={!isLoading ? onClick : null}>
            {isLoading ? <Spinner/> : <SaveButtonText>Opslaan</SaveButtonText>}
        </SaveButtonRoot>
    );
}


export const Tab = styled.div`
    background: ${({isActive}) => isActive ? secondaryRed : 'transparent'};
    color: ${({isActive}) => isActive ? white : primaryPurple};
    font-weight: 600;
    font-size: 16px;
    font-family: ${inter};
    padding: 6px 8px;
    white-space: nowrap;
    cursor: pointer;
`;

const TabWrapper = styled.div`
    width: 100%;
    max-width: 1280px;
    display: grid;
    grid-template-columns: minmax(44px, 1fr) minmax(0, 590px) minmax(44px, 1fr);
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;

    @media screen and ${device.laptopL} {
        max-width: 590px;
    }
    
    @media screen and ${device.mobileL} {
        grid-template-columns: minmax(44px, 1fr) minmax(0, 590px);
        padding-left: 16px;
        padding-right: 16px;
        box-sizing: border-box;
    }
`;

const TabBar = styled.div`
    grid-column: 2;
    background: ${secondaryGreenLight};
    height: 50px;
    width: 100%;
    display: flex;
    padding: 10px;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    overflow-x: auto;
    overflow-y: hidden;

    @media screen and ${device.laptopL} {
        grid-column: 1 / span 3;
        ${({$hasDownloadButton}) => $hasDownloadButton && "grid-column: 1 / span 2;"}
    }
`;

const HeaderContentFooterWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

const ScreenContent = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    padding: 20px 16px 54px 16px;
    flex: 1;

    @media screen and ${ device.tablet } {
        padding-bottom: 114px;
        overflow-y: auto;
    }

    @media screen and ${ device.mobileL } {
        padding: 0 0 84px;
        box-sizing: border-box;
    }
`;

const StyledPageHeader = styled(PageHeader)`
    margin-top: 13px;
    margin-bottom: 27px;
    width: 100%;
    max-width: 590px;

    @media screen and ${device.tablet} {
        margin-top: 0;
        margin-bottom: 10px;
    }

    @media screen and ${device.mobileL} {
        margin: 0;
    }
`

const StyledPageHeaderCenter = styled(PageHeader.Center)`
    display: flex;
    position: relative;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    gap: 4px;
    width: 100%;
`

const SelectorContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: end;
    gap: 10px;

    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    
    @media screen and ${device.tablet} {
        margin-left: auto;
    }
`

const SelectorWrapper = styled.div`
    margin-left: auto;

    @media screen and ${device.mobileL} {
        margin-right: 16px;
        margin-top: 8px;
    }
`

const DownloadButton = styled.button`
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    margin: 0;

    &:disabled {
        opacity: 0.5;
    }
`;

const DownloadButtonMobile = styled(DownloadButton)`
    display: none;

    @media screen and ${device.mobileL} {
        position: absolute;
        display: block;
        right: 0;
    }
`;

const DownloadButtonDesktop = styled(DownloadButton)`
    grid-column: 3;
    display: block;

    @media screen and ${device.mobileL} {
        display: none;
    }
`

const StyledDownloadIcon = styled(DownloadIcon)`
    display: block;
    width: 40px;
    height: 40px;
    color: ${primaryPurple};
    cursor: pointer;

    @media screen and ${device.mobileL} {
        width: 24px;
        height: 24px;
    }
`;

const SaveButtonRoot = styled.div`
    width: 125px;
    height: 35px;
    background: ${primaryPink};
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: flex-end;
    cursor: pointer;
`;

const SaveButtonText = styled.div`
    font-family: ${lemonMilk};
    font-size: 15px;
    color: ${white};
`;

export default PlanOfActionScreen;